export const ControlPropertyType = {
  Name: 'name',
  Value: 'value',
  Disabled: 'disabled',
  Placeholder: 'placeholder',
  Label: 'label',
  Error: 'error',
  ColorScheme: 'colorScheme',
  Id: 'id',
  Inline: 'inline',
} as const;

export const ControlEventType = {
  Input: 'input',
  Change: 'change',
  Focus: 'focus',
  Blur: 'blur',
} as const;

export const ControlStyleFillType = {
  Outlined: 'outlined',
  Dashed: 'dashed',
  Underlined: 'underlined',
} as const;

export const ControlType = {
  Textarea: 'textarea',
  NumberInput: 'numberInput',
  TextInput: 'textInput',
  PasswordInput: 'passwordInput',
  PhoneInput: 'phoneInput',
  Rating: 'rating',
  Radio: 'radio',
  DatePicker: 'datePicker',
  TimePicker: 'timePicker',
  FileUploader: 'fileUploader',
  Select: 'select',
  Checkbox: 'checkbox',
  Autocomplete: 'autocomplete',
  Cards: 'cards',
  IncrementInput: 'incrementInput',
} as const;
